import gql from 'graphql-tag';

import type { BlogOutlineSection } from 'src/data/blog';
import { executeGqlMutation } from 'src/graphql/client';
import { stringifyIfPresent } from 'src/lib/common';
import { getSingleProp } from 'src/lib/graphql';
import type { BackendMutationUpdateBlogPostBuilderOutlineSectionArgs } from 'src/types/backend';

import { FRAGMENT_PROJECT_BLOG_CONTENT_OUTLINE_SECTION } from './schema';

const MUTATION = gql`
  mutation UpdateBlogPostBuilderOutlineSection(
    $id: ID!
    $headline: String!
    $content: String
    $keywordsUsage: JSON
    $manualKeywords: [String!]
    $instructions: String
    $generationLength: BlogOutlineSectionGenerationLengthEnum
  ) {
    updateBlogPostBuilderOutlineSection(
      id: $id
      headline: $headline
      content: $content
      keywordsUsage: $keywordsUsage
      manualKeywords: $manualKeywords
      instructions: $instructions
      generationLength: $generationLength
    ) {
      ...BlogPostBuilderOutlineSection
    }
  }
  ${FRAGMENT_PROJECT_BLOG_CONTENT_OUTLINE_SECTION}
`;

type Variables = BackendMutationUpdateBlogPostBuilderOutlineSectionArgs;

export const updateBlogPostBuilderOutlineSection = async (variables: Variables) => {
  const result = await executeGqlMutation({
    mutation: MUTATION,
    variables: {
      ...variables,
      keywordsUsage: stringifyIfPresent(variables.keywordsUsage),
    },
  });

  return getSingleProp<BlogOutlineSection>(result.data);
};
